// extracted by mini-css-extract-plugin
export default {"tableHeader":"opoygCqfSF7vPV6fjiKr","infoCell":"G7Nr2NJmQ7ueBOyIjuFD"};